module.exports = __webpack_public_path__ + "img/quest_icon_0018_failed.ef4bc47e.png";